module.exports = __webpack_public_path__ + "static/img/gq2.34d0cf9c.jpg";